import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../animation/LoadingSpinner";
import { fetchAllUsers } from "../../redux/reducer/userReducer";

const AdminInfoSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { allUsers, loading, error } = useSelector((state) => state.users);
  const [searchBox, setSearchBox] = useState("");

  useEffect(() => {
    dispatch(fetchAllUsers());
  }, [dispatch]);
  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="text-red-500">{t("Error loading users")}</div>;
  }

  const filteredUsers = allUsers.filter((user) =>
    (user.boxNumber || "").toLowerCase().includes(searchBox.toLowerCase())
  );
  // console.log(allUsers);

  return (
    <div className="w-full overflow-x-auto">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold text-black">Users</h1>
        <input
          type="text"
          placeholder="Search by Box No"
          value={searchBox}
          onChange={(e) => setSearchBox(e.target.value)}
          className="px-2 py-1 text-black bg-gray-100 border rounded-md placeholder:text-black"
        />
      </div>

      {filteredUsers && filteredUsers.length > 0 ? (
        <table className="min-w-full mb-12 text-sm border border-gray-200 divide-y divide-gray-200">
          <thead className="font-bold cursor-pointer bg-custom-yellow">
            <tr>
              <th className="px-4 py-2 font-semibold text-center">{t("ID")}</th>
              <th className="px-4 py-2 font-semibold text-center">
                {t("Box Number")}
              </th>
              <th className="px-4 py-2 font-semibold text-center">
                {t("Name")}
              </th>
              <th className="px-4 py-2 font-semibold text-center">
                {t("Email")}
              </th>
              <th className="px-4 py-2 font-semibold text-center">
                {t("Phone")}
              </th>
              <th className="px-4 py-2 font-semibold text-center">
                {t("Orders")}
              </th>
              <th className="px-4 py-2 font-semibold text-center">
                {t("Created At")}
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {filteredUsers.map((user, index) => (
              <tr key={user.boxNumber}>
                <td className="px-4 py-2 text-center">{index + 1}</td>
                <td className="px-4 py-2 text-center">{user.boxNumber}</td>
                <td className="px-4 py-2 text-center">{user.name}</td>
                <td className="px-4 py-2 text-center">{user.email}</td>
                {user.countryCode && user.phone ? (
                  <td className="px-4 py-2 text-center">
                    {user.countryCode + " " + user.phone}
                  </td>
                ) : (
                  <td className="px-4 py-2 text-center">
                 Signup Google  
                  </td>
                )}

                <td className="px-4 py-2 text-center">{user.orders}</td>
                <td className="px-4 py-2 text-center">
                  {new Date(user.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-gray-500">{t("No users found")}</div>
      )}
    </div>
  );
};

export default AdminInfoSection;
